'use client';

import { useEffect, useState } from 'react';
import ym, { YMInitializer } from 'react-yandex-metrika';

import { browserRouter } from 'router';
import { hasCookieConsent, subscribeCookieConsent } from 'utils/cookieConsent';
import { isProfileAnalyticsHost } from 'utils/metrikaGoals';

const YM_COUNTER_ID = 105115263;

/** Счетчик кабинета включается только после кнопки Принять. */
const YandexMetrika = () => {
  const [consentGiven, setConsentGiven] = useState(false);

  useEffect(() => {
    if (!isProfileAnalyticsHost()) return;
    setConsentGiven(hasCookieConsent());
    return subscribeCookieConsent(() => {
      setConsentGiven(hasCookieConsent());
    });
  }, []);

  useEffect(() => {
    if (!consentGiven) return;
    let last = '';
    const hit = () => {
      const location = browserRouter.state.location;
      if (!location) return;
      const next = `${location.pathname}${location.search}`;
      if (!next || next === last) return;
      last = next;
      ym('hit', next);
    };
    hit();
    return browserRouter.subscribe(hit);
  }, [consentGiven]);

  if (!consentGiven) return null;

  return (
    <YMInitializer
      accounts={[YM_COUNTER_ID]}
      options={{
        defer: true,
        webvisor: true,
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        trustedDomains: ['myteacher.pro', 'profile.myteacher.pro'],
      }}
      version='2'
    />
  );
};

export default YandexMetrika;
